import { FormControl } from 'baseui/form-control'
import { ModalBody, ModalButton, ModalFooter } from 'baseui/modal'
import { ArrowRight } from 'baseui/icon'
import { Spinner } from 'baseui/spinner'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import usePceSearchV2 from './usePceSearchV2'
import useRetrievePCEsV2 from './useRetrievePCEsV2'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import AddressSelect from '@/containers/SubscriptionFormPageNew/Components/shared/AddressSelect/AddressSelect'

const PceSearchForm = () => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const {
    getAddress,
    getOccupant,
    getSerialNumber,
    isFormFilled,
    isLoading,
    updatePceConfigData,
    updateAddressHandler,
  } = usePceSearchV2()
  const { searchPCEs } = useRetrievePCEsV2()

  return (
    <>
      <ModalBody>
        <div className={css({ padding: '1rem 0' })}>
          <AddressSelect
            currentValue={getAddress}
            onChange={updateAddressHandler}
            disabled={isLoading}
            placeholder={t('subscriptionTools:pce_search.fields.address')}
          />

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pce_search.fields.occupant')}
              currentValue={getOccupant}
              onBlur={value => updatePceConfigData({ occupant: value || '' })}
              disabled={isLoading}
            />
          </FormControl>

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pce_search.fields.serial_number')}
              currentValue={getSerialNumber}
              onBlur={value => updatePceConfigData({ serialNumber: value || '' })}
              disabled={isLoading}
            />
          </FormControl>
        </div>
      </ModalBody>

      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f7f7f7',
          borderTop: '0.0625rem solid #e0e0e0',
          padding: '1rem 1.5rem',
        }}
      >
        <ModalButton
          id='button-start-search'
          endEnhancer={() => <ArrowRight size={24} />}
          disabled={!isFormFilled || isLoading}
          onClick={searchPCEs}
        >
          {t('subscriptionTools:pce_search.start_search')}
        </ModalButton>
        {isLoading && <Spinner size={24} />}
      </ModalFooter>
    </>
  )
}

export default PceSearchForm
